import { StrictMode, type ReactNode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.js";
import { currentAccount, signIn } from "./auth/msal.js";
import { SiteHeader } from "./components/SiteHeader.js";
import "./styles/tokens.css";
import "./styles/base.css";

const el = document.getElementById("root");
if (el) {
  const root = createRoot(el);
  const render = (node: ReactNode) => root.render(<StrictMode>{node}</StrictMode>);

  const message = (title: string, text: string) => (
    <>
      <SiteHeader title="Ask HR" />
      <main className="wrap">
        <section className="panel">
          <h2>{title}</h2>
          <p className="sub">{text}</p>
        </section>
      </main>
    </>
  );

  render(message("Signing you in…", "One moment."));
  currentAccount()
    .then((account) => (account ? render(<App account={account} />) : signIn()))
    .catch(() =>
      render(
        message(
          "Couldn't sign you in",
          "Reload the page to try again. If it keeps happening, you may not have access to Ask HR yet; ask IT.",
        ),
      ),
    );
}
